import { Context } from '../server-middleware/context'

export default async function getConfigWithPrisma (context: Context, key: string): Promise<string|null> {
  const cache = context.cache(key)
  const cachedValue = await cache.get()
  if (typeof cachedValue === 'string') return cachedValue

  const row = await context.prismaClient.config_community.findFirst({ where: { key } })
  if (row?.value) {
    await cache.set(row.value)
  }
  return row ? JSON.parse(row.value || '') : null
}
